// True when an <audio>/<video> `error` event is just the benign "no source
// yet" idle state — the element is mounted but no track is loaded — rather than
// a real playback failure.
//
// Browsers fire MEDIA_ELEMENT_ERROR (code 4) with "Empty src attribute" when
// the element's src is '' or absent. That's the expected state for our bottom
// player before the first track plays, and for the iOS warmup element on
// teardown, so it should be suppressed silently. Genuine failures (CDN 503,
// unsupported format, decode error) still carry a real message and ARE logged.
export function isEmptySrcMediaError(target) {
    if (!target) return false;
    const msg = target.error?.message || '';
    if (/empty src/i.test(msg)) return true;
    // No usable source attached at all.
    return !target.currentSrc && !target.getAttribute?.('src');
}
